import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ConfService} from '../../conf.service';
import {environment} from '../../../environments/environment';
import {interval} from 'rxjs';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {ImportVariablesComponent} from '../import-variables/import-variables.component';
import {MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
  selector: 'ap-view-accelerator',
  templateUrl: './view-accelerator-category.component.html',
  styleUrls: ['./view-accelerator-category.component.scss']
})
export class ViewAcceleratorCategoryComponent implements OnInit {

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');

  accelerator_id: any;
  integration_id: any;
  acceleratorName: any;

  acceleratorData: any;
  acceleratorConnectorVariables: any;
  connectors: any[] = [];
  componentLoading = true;
  acceleratorConnectorComponentLoading = true;
  dataLoading = true;
  errorOccured = false;

  acceleratorConnectorDataLoading = true;
  acceleratorConnectorErrorOccured = false;
  errorMessage = '';

  viewPermission = false;
  selectedIndex: any;

  viewableComponent = 'combined'; // combined || individual

  constructor(private route: ActivatedRoute,
              private confSrv: ConfService,
              public platform: LeftpanelComponent,
              public dialog: MatDialog,
              public accountInfoService: AccountInfoService
  ) {}

  ngOnInit() {

    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    const permissionSubscription = interval(500).subscribe((async x => {
        permissionSubscription.unsubscribe();
        this.viewPermission = this.platform.hasPlatformPermission('VIEW_ACCELERATORS');
        if (this.viewPermission) {
          this.initPage();
        } else {
          this.componentLoading = false;
        }
    }));
  }

  initPage(change = true) {

    if (change) {
      this.route.queryParams.subscribe((params) => {
        if (params.selectedIndex) {
          this.selectedIndex = params.selectedIndex;
          // this.router.navigate([], {
          //   queryParams: {
          //     selectedIndex: null,
          //   },
          //   queryParamsHandling: 'merge',
          // });
        } else {
          this.selectedIndex = 0;
        }
      });
    }

    this.route.params.subscribe(params => {
      if (params && params.integration_id) {
        if (params.accelerator_id) {
          this.accelerator_id = params.accelerator_id;
          this.viewableComponent = 'individual';
        }
        this.integration_id = params.integration_id;

        Promise.resolve(this.retrieveData()).then(response => {
          this.componentLoading = false;
        }, error => {
          this.componentLoading = false;
        });

        Promise.resolve(this.retrieveAcceleratorConnectors()).then(response => {
          this.acceleratorConnectorComponentLoading = false;
        }, error => {
          this.acceleratorConnectorComponentLoading = false;
        });
      }
    });
  }

  retrieveAcceleratorConnectors() {
    return new Promise((resolve, reject) => {
      this.acceleratorConnectorDataLoading = true;
      this.acceleratorConnectorErrorOccured = false;
      const payload = {
        significance: 'compose',
        intent: 'connectors',
        partner: this.partner,
        account: this.account,
        data: {
          integration_title: this.integration_id
        }
      };
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.acceleratorConnectors.name, environment.integrationsAPI.acceleratorConnectors.version, payload).subscribe(data => {
        let resp: any;
        resp = data;
        this.connectors = resp.items;
        this.acceleratorConnectorDataLoading = false;
        resolve();
      }, error => {
        this.acceleratorConnectorErrorOccured = true;
        this.acceleratorConnectorDataLoading = false;
        reject('Unable to load data');
      });
    });
  }

  retrieveData() {
    return new Promise((resolve, reject) => {
      this.dataLoading = true;
      this.errorOccured = false;
      const payload = {
        significance: 'compose',
        intent: (this.viewableComponent === 'combined') ? 'accelerators' : 'accelerator',
        search: {
          query: (this.viewableComponent === 'combined') ? this.integration_id : this.accelerator_id,
        }
      };
      // "significance": "generate",
      //     "intent": "subscriptions",
      //     "partner": "hari",
      //     "account": "hari",
      //     "data": {
      //   "integration": "kong_ap_api",
      //       "enabled": true
      // },
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.accelerators.name, environment.integrationsAPI.accelerators.version, payload).subscribe(data => {
        let resp: any;
        resp = data;
        this.acceleratorData = (this.viewableComponent === 'combined') ? resp['item']['accelerators'] : resp['item'];
        this.acceleratorConnectorVariables = resp['item']['connector_variables'];
        this.dataLoading = false;
        resolve();
      }, error => {
        this.errorOccured = true;
        this.dataLoading = false;
        reject('Unable to load data');
      });
    });
  }

  viewConnector(connector: any) {
    const dialogRef = this.dialog.open(ImportVariablesComponent, {
      height: 'auto',
      width: '70%',
      data: {
        accelerator_variables: [],
        connector_variables: connector.connector_variables,
        name: connector.name,
        viewConnectorFlag: true,
        integration_title: this.integration_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.initPage();
        // this.appendToDomWithChange(type, blockText, blockAttributes, result.accelerator_variables, result.connector_variables);
      }
    });
  }

  editConnector(connector: any) {
    const dialogRef = this.dialog.open(ImportVariablesComponent, {
      height: 'auto',
      width: '70%',
      data: {
        accelerator_variables: [],
        connector_variables: connector.connector_variables,
        name: connector.name,
        connectorFlag: true,
        integration_title: this.integration_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.initPage();
        // this.appendToDomWithChange(type, blockText, blockAttributes, result.accelerator_variables, result.connector_variables);
      }
    });
  }

  importAcceleratorIntoWorkspace(accelerator_variables, connector_variables) {
    const dialogRef = this.dialog.open(ImportVariablesComponent, {
      height: 'auto',
      width: '70%',
      data: {
        accelerator_variables: [],
        connector_variables: connector_variables,
        acceleratorFlag: true,
        integration_title: this.integration_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.initPage(false);
        // this.appendToDomWithChange(type, blockText, blockAttributes, result.accelerator_variables, result.connector_variables);
      }
    });
  }

}
